import { useCallback } from 'react';
import styled from 'styled-components';
import { InputBase } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import { Flex } from '../Flex';
import { useStores } from '../../hooks/useStores';

const InputDiv = styled(Flex)`
  overflow: hidden;
  max-width: 178px;
  width: 100%;
  height: 30px;
  border: 1px solid ${({ theme }) => theme.colors.neutrals[3]};
  border-radius: 2px;
  margin-right: ${({ theme }) => theme.space[4]}px;
  background-color: ${({ theme }) => theme.colors.whites[9]} !important;
`;

const SearchField = styled(InputBase)`
  && {
    color: black;
    margin-left: ${({ theme }) => theme.space[2]}px;
    font-size: ${({ theme }) => theme.fontSizes[1]}px;
  }
`;

const TableSearch = ({ handleSearchQuery }) => {
  const { productStore } = useStores();
  const debounceQuery = useCallback(
    debounce((query) => handleSearchQuery(query), 500),
    []
  );

  const handleOnChange = (event) => {
    if (isEmpty(event.target.value)) {
      productStore.clearSearchResults();
    }
    debounceQuery(event.target.value);
  };

  return (
    <div>
      <InputDiv alignItems="center">
        <SearchField
          data-testid="table-search"
          name="search"
          placeholder="Search"
          onChange={handleOnChange}
        />
        <SearchIcon />
      </InputDiv>
    </div>
  );
};

export default TableSearch;
